import { render, staticRenderFns } from "./PurchaceOrderList.vue?vue&type=template&id=0adfd48c&scoped=true"
import script from "./PurchaceOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaceOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adfd48c",
  null
  
)

export default component.exports